import { z } from 'zod';

export const PartnerSummarySchema = z.object({
  partnerUID: z.number(),
  partnerInquiryUID: z.number(),
  parentPartnerUID: z.number(),
  partnerName: z.string(),
  partnerType: z.string(),
  partnerTypeString: z.string(),
  partnerLevel: z.string(),
  partnerLevelString: z.string(),
  partnerStatus: z.string(),
  partnerStatusString: z.string(),
  partnerSiteURL: z.string(),
  partnerPhoneNumber: z.string(),
  partnerContactEmail: z.string(),
  partnercontactName: z.string(),
  soLoginUID: z.number(),
  billingType: z.string(),
  companyName: z.string(),
  creationDate: z.string(),
  partnerCurrency: z.string(),
});

export type PartnerSummaryResponse = z.infer<typeof PartnerSummarySchema>;
